import { APP_INITIALIZER, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

// Components
import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideRouter, RouterModule } from '@angular/router';
import { AccordionModule } from 'primeng/accordion';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { CardModule } from 'primeng/card';
import { ChartModule } from 'primeng/chart';
import { CheckboxModule } from 'primeng/checkbox';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { DialogModule } from 'primeng/dialog';
import { FloatLabelModule } from 'primeng/floatlabel';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { MenuModule } from 'primeng/menu';
import { MenubarModule } from 'primeng/menubar';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RippleModule } from 'primeng/ripple';
import { SelectModule } from 'primeng/select';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SidebarModule } from 'primeng/sidebar';
import { SplitButtonModule } from 'primeng/splitbutton';
import { TableModule } from 'primeng/table';
import { Textarea } from 'primeng/textarea';
import { ToastModule } from 'primeng/toast';
import { AboutComponent } from './about/about.component';
import { AccessDeniedComponent } from './access-denied/access-denied.component';
import { AcknowledgementsComponent } from './acknowledgements/acknowledgements.component';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { AuthGuard } from './auth.guard';
import { CompanyManagementComponent } from './company-management/company-management.component';
import { FooterComponent } from './footer/footer.component';
import { HomeComponent } from './home/home.component';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { LoadingSpinnerComponent } from './loading-spinner/loading-spinner.component';
import { LoginComponent } from './login/login.component';
import { MockupPageComponent } from './mockup-page/mockup-page.component';
import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { ProductsComponent } from './products/products.component';
import { AuthService } from './services/auth.service';
import { ConfigService } from './services/config-service.service';
import { RestApiService } from './services/restApiService.service';
import { UserManagementComponent } from './user-management/user-management.component';


import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { Flyht } from './themes/flyht';

@NgModule({

  imports: [
    BrowserModule,
    RouterModule.forRoot([], {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    }),
    SplitButtonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastModule,
    MultiSelectModule,
    TableModule,
    ChartModule,
    SidebarModule,
    BrowserAnimationsModule,
    MenuModule,
    MenubarModule,
    AccordionModule,
    ButtonModule,
    RippleModule,
    SelectButtonModule,
    CalendarModule,
    CheckboxModule,
    SelectModule,
    AutoCompleteModule,
    DialogModule,
    ConfirmDialogModule,
    ProgressSpinnerModule,
    ProgressBarModule,
    InputSwitchModule,
    FloatLabelModule,
    Textarea,
    InputTextModule,
    CardModule,
    AvatarModule
  ],
  declarations: [
    HomeComponent,
    NavMenuComponent,
    FooterComponent,
    LoadingSpinnerComponent,
    LoginComponent,
    ProductsComponent,
    AboutComponent,
    MockupPageComponent,
    AccessDeniedComponent,
    UserManagementComponent,
    CompanyManagementComponent,
    AcknowledgementsComponent,
    AppComponent,
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: (envConfigService: ConfigService) => () => envConfigService.load(),
      deps: [ConfigService],
      multi: true
    },
    AuthGuard,
    AuthService,
    MessageService,
    RestApiService,
    ConfirmationService,
    DatePipe,
    provideRouter(routes),
    provideHttpClient(withInterceptors([AuthInterceptor])),
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Flyht,
        options: {
          darkModeSelector: '.dark-mode-selector'
        }
      }
    })
  ],
  bootstrap: [AppComponent]
})


export class AppModule { }
